import React, { useEffect, useState } from 'react'
import { edit_icon, eye_icon, search_icon, view_icon } from '../../assets/imgs'
import { useNavigate } from 'react-router-dom'
import { Table } from '../../components/Table/Table'
import { useLazyAdminListStatusQuery, useReceptionListMutation, useReceptionStatusMutation } from '../redux/api/api'
import moment from 'moment'
import { toast } from 'react-toastify'

const ReceptionList = () => {
    const navigate = useNavigate()
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [list, setList] = useState([]);
    const [count, setCount] = useState()
    const [status, setStatus] = useState()
    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    const [receptionListApi] = useReceptionListMutation();
    const [receptionListStatus] = useReceptionStatusMutation();

    const receptionStatus = (id, value) => {
        const formdata = new FormData();
        formdata.append("id", id)
        formdata.append("status", value)
        receptionListStatus(formdata)
            .unwrap()
            .then((res) => {
                console.log("reasds", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    receptionList()
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const receptionList = (page, search) => {
        const formdata = new FormData();
        formdata.append("page", page)
        formdata.append("row", 10)
        if (search) {
            formdata.append('search', search)
        }
        receptionListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let temp = []
                res?.data?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setCount(res?.pagination?.total);
                setPagecount(res?.pagination)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        receptionList(pageno);
    }, [pageno]);



    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Receptionist Id",
                accessor: "reception_id",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/recpetion-view", { state: { type: "view", id: row.original.id } })}>{value}</p></div>
                },
            },
            {
                Header: "Receptionist Name",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/recpetion-view", { state: { type: "view", id: row.original.id } })}>{value}</p></div>
                },
            },
            {
                Header: "Owner Name",
                accessor: "owner",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner_id } })}>{value?.name}</p></div>
                },
            },

            {
                Header: "Created Date",
                accessor: "created_at",
                Cell: ({ value, row }) => {
                    return <p>{moment(value).format("DD-MM-YYYY")}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            {/* <select disabled={(row.original.account_status == 1 && rolePermissions?.includes('CAN-STATUS-RECEPTIONIST')) ? false : true} */}
                            <select disabled={rolePermissions?.includes('CAN-STATUS-RECEPTIONIST') ? false : true}
                                value={value}
                                onChange={(e) => { receptionStatus(row.original.id, e.target.value) }}
                                className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 1 ? "active-btn" : "suspend-btn"}`}
                            >
                                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1}>
                                    Active
                                </option>
                                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={2}>
                                    Deactive
                                </option>
                            </select>
                        </React.Fragment >
                    );
                },
            },
            {
                Header: "Account Status",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row?.original?.owner?.account_status == 1 ? "Active" : row?.original?.owner?.account_status == 0 ? "Deactive" : ""}</p>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-VIEW-RECEPTIONIST') &&
                                    <button
                                        onClick={() => navigate("/recpetion-view", { state: { type: "view", id: row.original.id } })}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>}
                                {rolePermissions?.includes('CAN-EDIT-RECEPTIONIST') &&
                                    <button
                                        onClick={() => navigate("/recpetion-add", { state: { type: "edit", id: row.original.id } })}
                                        className="cust-btn "
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn" />
                                    </button>
                                }
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );



    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Receptionist({count})
                </h2>
                <div className='d-flex gap-3'>
                    <div className='search-input'>
                        <input type='text' onChange={(e) => (receptionList(1, e.target.value))} placeholder='Search' style={{ border: 'none', width: '150px', fontFamily: 'f1' }} />
                        <img src={search_icon} className='search' />
                    </div>
                    {rolePermissions?.includes('CAN-ADD-RECEPTIONIST') &&
                        <button onClick={() => navigate('/recpetion-add')} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add </button>}
                </div>
            </div>
            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
        </div>
    )
}

export default ReceptionList